'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StaticControl = function () {
  function StaticControl(element, args) {
    _classCallCheck(this, StaticControl);

    var div = document.createElement('div');
    this.property = document.createElement('div');
    this.property.id = window.PRIM.getUUID();
    this.property.innerHTML = args.value ? args.value : '';
    this.label = document.createElement('label');
    this.label.innerHTML = args.label;
    this.label.htmlFor = this.property.id;
    var fragment = document.createDocumentFragment();
    fragment.appendChild(div);
    div.appendChild(this.label);
    div.appendChild(this.property);

    element.appendChild(fragment);
  }

  _createClass(StaticControl, [{
    key: 'setLabel',
    value: function setLabel(text) {
      this.label.innerHTML = text;
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.property.innerHTML;
    }
  }, {
    key: 'setValue',
    value: function setValue(value) {
      this.property.innerHTML = value ? value : '';
    }
  }]);

  return StaticControl;
}();

exports.default = StaticControl;


//////////////////
// WEBPACK FOOTER
// ./js/lib/ui/StaticControl.js
// module id = 18
// module chunks = 0